import React from "react";
import { Button } from "../button/Button";
import { Flex } from "./FlexHelpers";
import { Select } from "../inputs/Select";
import { TextInput } from "../inputs/TextInput";
import { InputMessage } from "../InputMessage";

type SingleTagEditorProps = {
    availableTags: string[];
    selectedTag:string;
    disabled?:boolean;
    validator:(tag:string) => boolean;
    onChange:(tag:string) => void;
    texts: {
        selectTagOption:string,
        createTagOption:string,
        newTagPlaceholder:string
    }
}

export function SingleTagEditor(props:SingleTagEditorProps):JSX.Element
{
    const createNewTagOptionValue = "__$$create_new_tag$$__";

    const [newTag, setNewTag] = React.useState<{value:string, showError:boolean} | null>(null);

    function handleSelectTagOption(tagValue: string)
    {
        if (props.disabled)
            return;
        
        if(tagValue === createNewTagOptionValue)
        {
            setNewTag({ value: "", showError:false });
            return;
        }
        else {
            setNewTag(null);
        }

        props.onChange(tagValue);
    }

    function handleClickAddNewTag()
    {
        if(!newTag)
            return;

        if (props.disabled)
            return;

        const valid = props.validator(newTag.value);
        if(valid)
        {
            props.onChange(newTag.value);
            setNewTag(null);
        }
        else
        {
            setNewTag({ ...newTag, showError:true });
        }
    }

    return (
        <Flex flexDirection="column" gap={12}>
            <Flex flexDirection="column" gap={8}>
                <Flex alignItems="flex-end" gap={8}>
                    <Select 
                        options={[
                            { value: "", text: props.texts.selectTagOption },
                            ...props.availableTags.map((tag) => ({ value: tag, text: tag })),
                            { value: createNewTagOptionValue, text: props.texts.createTagOption }
                        ]}
                        selectedValue={props.selectedTag}
                        disabled={props.disabled}
                        onChange={handleSelectTagOption}
                    />
                </Flex>

                {newTag !== null &&
                    <Flex flexDirection="column" gap={8}>
                        <Flex>
                            <TextInput
                                inErrorState={newTag.showError}
                                placeholder={props.texts.newTagPlaceholder}
                                value={newTag.value}
                                disabled={props.disabled}
                                onChange={(value) => setNewTag({ ...newTag, value })}
                            />
                            <Button
                                variant="text"
                                onClick={handleClickAddNewTag}
                                text="Opret"
                                disabled={props.disabled || !newTag.value.trim()} 
                            />
                        </Flex>
                        {newTag.showError &&
                            <InputMessage inErrorState={true}>Ugyldig værdi</InputMessage>
                        }
                    </Flex>
                }
            </Flex>
        </Flex>
    );
}